/** Home hero copy in Arabic. Mirrors `../../en/home/hero.js` key for key. */
import { ACTIONS } from '../site'

export const HERO = {
  eyebrow: 'MeetNPlan',
  title: 'مكتبك يعمل بالاجتماعات.',
  text: 'وهكذا يبقيها MeetNPlan تسير بسلاسة.',
  scroll: 'مرّر',
  frames: [
    { title: 'كل شيء يبدأ بقاعة متاحة.', text: 'اعرف المتاح واحجزه بلمسة واحدة.' },
    { title: 'ثم يصل ضيفك.', text: 'يسجّل الاستقبال دخوله ويُبلغ المضيف.' },
    {
      title: 'الموارد البشرية على اطلاع.',
      text: 'تُعتمد الطلبات قبل تأكيد أي شيء.',
    },
    {
      title: 'فريقك على تواصل دائم.',
      text: 'رسائل ومحادثات جماعية، في مكان الاجتماع نفسه.',
    },
    {
      title: 'وكل شيء يصل إلى تقويمك.',
      text: 'يتزامن كل حجز مع تقويم Google.',
    },
    { title: 'كل ذلك في تطبيق واحد.', text: 'رحّب بـ…' },
  ],
  wordmark: 'MEETNPLAN',
  closing: 'تطبيق واحد لكل اجتماع وقاعة وزائر.',
  primary: ACTIONS.demo,
  secondary: { label: 'تعرّف على المنتج', href: '/#product' },
}
